module.exports = __webpack_public_path__ + "img/part6-icon6.b52616cd.png";